import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const analysisPermissions = { view: "analysis.view", execute: "analysis.execute" };

export const analysisGrants = {
  "analysis.view": rule(lud(R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  // Running a report analysis (POST /report/analyze-lud) WRITES Compensation /
  // Daily / Monthly rows, so it is its own permission and not analysis.view.
  // Same roles as the page that runs it (lud.view: /auth/lud): the delivery
  // managers who upload and approve the daily/monthly reports (dm already holds
  // report.approve and manages the report-file categories of LUD documents).
  // Restaurant-scoped: dm reaches only the stores assigned to them.
  "analysis.execute": rule(lud(R.DM, R.DMM), { scope: SCOPES.RESTAURANT }),
};
